// Global on/off switch for Google sign-in, so it can never be enabled on one
// auth page (e.g. /register) and disabled on another (e.g. /login) — both
// pages render this same component. Set VITE_GOOGLE_LOGIN_DISABLED=true to
// turn it off everywhere at once.
const GOOGLE_LOGIN_ENABLED = import.meta.env.VITE_GOOGLE_LOGIN_DISABLED !== 'true'

export function SocialAuthButtons({ redirectTo }: { redirectTo?: string }) {
  function buildUrl(provider: 'google' | 'facebook') {
    const base = `/api/v1/auth/${provider}`
    return redirectTo ? `${base}?redirectTo=${encodeURIComponent(redirectTo)}` : base
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {GOOGLE_LOGIN_ENABLED && (
        <a
          href={buildUrl('google')}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            padding: '11px 16px', borderRadius: 12, border: '1.5px solid var(--line)',
            background: 'var(--surface)', color: 'var(--ink)', fontSize: 14, fontWeight: 600,
            textDecoration: 'none', fontFamily: '"Outfit", system-ui, sans-serif',
            transition: 'border-color 0.15s, box-shadow 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--primary)'; e.currentTarget.style.boxShadow = '0 0 0 3px var(--primary-soft)' }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.boxShadow = 'none' }}
        >
          <GoogleIcon />
          Continue with Google
        </a>
      )}

      {/* Facebook auth temporarily hidden until OAuth app is approved
      <a
        href={buildUrl('facebook')}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          padding: '11px 16px', borderRadius: 12, border: '1.5px solid #1877F2',
          background: '#1877F2', color: '#fff', fontSize: 14, fontWeight: 600,
          textDecoration: 'none', fontFamily: '"Outfit", system-ui, sans-serif',
          transition: 'opacity 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.88' }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = '1' }}
      >
        <FacebookIcon />
        Continue with Facebook
      </a>
      */}
    </div>
  )
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
      <path d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.962L3.964 6.294C4.672 4.167 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  )
}

// Kept for the Facebook auth button above, which is hidden until the OAuth app is approved.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
      <path d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.269h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
    </svg>
  )
}
